import * as React from 'react';
import { NavLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import {Box,Grid} from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
// import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import AdminSalesMetrics from './admin/Admin';
import DoughnutChart from './admin/PassReviews';
import { SimpleCard } from 'app/components';
import { useTheme } from '@emotion/react';
import { AutoAwesome } from '@mui/icons-material';

export default function ButtonAppBar() {

  const theme  = useTheme()

    const [open, setOpen] = React.useState(false);
     

    const toggleDrawer = (newOpen) => () => {
      setOpen(newOpen);
    };

   const logoutHandle = ()=>{
        localStorage.removeItem('admin')
   }
  
    const DrawerList = (


      <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
        <List>
          {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          {['All mail', 'Trash', 'Spam'].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>

      
    
    );

    
  return (
    <>
    <AdminSalesMetrics />

    {/* sx={{height:'fit-content'}} style={{ height: 'fit-content'}} */}
    <Box >

     <DoughnutChart  
     height="400px"
          color={[
            theme.palette.primary.dark,
      theme.palette.primary.main,           
      theme.palette.secondary.dark,
      // theme.palette.secondary.main,
     "#2ECC71",
     
       "#8E44AD",
        "#33FF57", "#3357FF",
  "#33FFFF",  "#FF9633", "#3396FF",
  "#96FF33", 
  "#FF3396",
     
          ]} />

    </Box>

   


    </>
  );
}